export default "__VITE_ASSET__CrfC$mVq__"